import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpService } from '../../core';
import { Observable } from 'rxjs';
import { SmBaseService } from '../../core';
import { map } from 'rxjs/operators';

@Injectable()
export class AutomaticExportService extends SmBaseService {
    constructor(http: HttpService) {
        super(http, 'automaticExport');
    }

    get(): Observable<AutomaticExportModel> {
        return this._get().pipe(map((res: Response) => {
            return res.json() as AutomaticExportModel;
        }));
    }

    set(model: AutomaticExportModel) {
        return this._post('', model);
    }

    delete(id: number) {
        return this._delete(id);
    }
}

export class AutomaticExportModel {
    id: number;
    email: string;
    emailFromAccount: boolean;
    exportQuarterly: boolean;
    exportTemplateId: number;
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/services/automatic-export.service.ts